import { createSlice } from '@reduxjs/toolkit';
import { setNormalizedData, initialEntityStructure } from 'libs/utils/redux';
import { stateName } from './constants';
export const initialState = {
  cities: initialEntityStructure,
  countries: initialEntityStructure
};

const searchCitiesSuccess = (draft, action) => {
  const {
    cities
  } = action.payload;
  setNormalizedData(draft.cities, cities);
};

const fetchCountriesSuccess = (draft, action) => {
  const {
    countries
  } = action.payload;
  setNormalizedData(draft.countries, countries);
};

const locationSlice = createSlice({
  name: stateName,
  initialState,
  reducers: {
    searchCitiesSuccess,
    fetchCountriesSuccess
  }
});
export const {
  actions
} = locationSlice;
export const plug = {
  [stateName]: locationSlice.reducer
};
export default locationSlice.reducer;